// This component is generated by svgr. DO NOT EDIT.
import { SVGProps } from 'react'
type Props = {
  size?: 'sm' | 'md' | 'lg' | (string & {}),
} & Omit<SVGProps<SVGSVGElement>, 'width' | 'height'>
const SvgError = ({ size = 'md', ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    height={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill={props.color ?? 'currentColor'}
      fillRule="evenodd"
      d="M1.94 1.94a1.5 1.5 0 0 1 2.12 0L8 5.878l3.94-3.94a1.5 1.5 0 0 1 2.12 2.122L10.122 8l3.94 3.94a1.5 1.5 0 0 1-2.122 2.12L8 10.122l-3.94 3.94a1.5 1.5 0 0 1-2.12-2.122L5.878 8l-3.94-3.94a1.5 1.5 0 0 1 0-2.12"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgError
